<template>
  <TournamentForm :isEdit="true" :id="id || $route.params.id" />
</template>

<script>
import TournamentForm from "@/components/tournament/TournamentForm.vue";

export default {
  name: "TournamentEditPage",
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    TournamentForm,
  },
};
</script>
